exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.battery-order-view__cell .checkbox label {\n  padding-left: 0;\n}\n", ""]);

